import ActionPanelContainer from './action_panel_container';

const ActionPanel = ActionPanelContainer;

export default ActionPanel;
